<template>
    <div :style="'font-size:'+fontSize+'px'" class="mediaPreview-content">
        <p :title="info.title" class="title">{{info.minTitle}}</p>
        <div class="video">
            <video controls :cover="info.cover" ref="video" :src="info.video_url"></video>
            <div class="speedRate">
                <div @click="showSelectList=!showSelectList" class="btn">
                    <span>{{nowSpeed}}</span>
                    <img src="./assets/whiteArrow.svg" alt="">
                </div>
                <div v-if="showSelectList" class="btnList">
                    <p></p>
                    <ul>
                        <li @click="changeSpeed('1x')">1x</li>
                        <li @click="changeSpeed('2x')">2x</li>
                        <li @click="changeSpeed('4x')">4x</li>
                    </ul>
                </div>
            </div>
            <div @click="toMaterial(info.video_url)" class="toMaterial">
                <i></i>
                <span>我的素材</span>
            </div>
        </div>
        <div class="info">
            <div class="title">详情</div>
            <ul>
                <li>
                    <div class="left">
                        <i class="tag"></i>
                        <span>{{info.client_name}}</span>
                    </div>
                    <div class="right">
                        <i class="zan"></i>
                        <span>点赞数：{{info.like_num}}</span>
                    </div>
                </li>
                <li>
                    <div class="left">
                        <i class="upload"></i>
                        <span>{{info.type}}</span>
                    </div>
                    <div class="right">
                        <i class="comment"></i>
                        <span>评论数：{{info.comment_num}}</span>
                    </div>
                </li>
                <li>
                    <div class="left">
                        <i class="user"></i>
                        <span>{{info.author}}</span>
                    </div>
                    <div class="right">
                        <i class="share"></i>
                        <span>转发数：{{info.share_num}}</span>
                    </div>
                </li>
                <li>
                    <div class="left">
                        <i class="time"></i>
                        <span>{{info.raw_add_time}}</span>
                    </div>
                </li>
            </ul>
        </div>
        <div v-if="info.url" class="btns">
            <p @click="navigate(info.url)" class="btn">
                <i class="link"></i>
                <span>查看原文</span>
            </p>
            <!-- <p class="btn">
                <i class="download"></i>
                <span>下载</span>
            </p> -->
        </div>

    </div>
</template>

<script>
import common from "@common/common";
import {apis} from '@common/config'

export default {
    props: {
        info: {
            type: Object
        }
    },
    data() {
        return {
            fontSize: 100,
            nowSpeed: "1x",
            showSelectList: false
        }
    },
    methods: {
        toMaterial(url) {
            let info = {
                url: url,
                title: this.info.title
            }

            common.myFetch(apis.browserdownload, info).then((res) => {
                if(res){
                this.$toast(res)
                }
                // console.log(res)
            })
        },
        navigate(url) {
            common.jumpOut(url)
        },
        recalc() {
            var clientWidth = document.documentElement.clientWidth;

            if (!clientWidth) {

                return;
            }

            var p = 100 * (clientWidth / 1334);

            this.fontSizeWrite = p

            if(p<97.3){
                p=97.3
            }else if(p>110){
                p=110
            }

            this.fontSize = p
        },
        changeSpeed(speed) {
            this.nowSpeed = speed;
            let multiple = 1;
            if (speed === "1x") {
                multiple = 1;
            } else if (speed === "2x") {
                multiple = 2;
            } else {
                multiple = 4;
            }
            this.$refs.video.playbackRate = multiple;
            this.showSelectList = false;
        }
    },
    beforeDestroy() {
        let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
        window.removeEventListener(resizeEvt, this.recalc, false);
    },
    mounted() {
        let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';

        window.addEventListener(resizeEvt, this.recalc, false);

        this.recalc()
    }
}
</script>

<style lang="less" scoped>
    .mediaPreview-content {
        display: flex;
        flex-direction: column;
        width: 7.1em;
        height: fit-content;
        padding: 0.22em 0.3em 0.3em;
        background: #F9F9F9;
        box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
        border-radius: 4px;
        box-sizing: border-box;

        &>.title {
            font-size: 0.22em;
            line-height: 1.364em;
            color: #050F0F;
            font-weight: bold;
            word-break: break-all;
            margin-bottom: 1em;
        }

        .video {
            position: relative;
            width: 100%;
            height: 3.66em;
            margin-bottom: 0.22em;

            video {
                width: 100%;
                height: 100%;
            }

            .speedRate {
            position: absolute;
            top: 14px;
            right: 14px;

            .btn {
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              width: 62px;
              height: 30px;
              border-radius: 15px;
              background: rgba(0, 0, 0, 0.3);
              user-select: none;
              cursor: pointer;

              span {
                display: block;
                font-size: 16px;
                line-height: 30px;
                color: #fff;
              }

              img {
                margin-left: 4px;
              }
            }

            .btnList {
              display: flex;
              flex-direction: column;

              p {
                height: 10px;
              }

              ul {
                display: flex;
                flex-direction: column;
                border-radius: 4px;
                overflow: hidden;
                background: rgba(0, 0, 0, 0.3);

                li {
                  width: 100%;
                  height: 30px;
                  line-height: 30px;
                  text-align: center;
                  font-size: 16px;
                  color: #fff;
                  user-select: none;
                  cursor: pointer;

                  &:hover {
                    background: rgba(0, 0, 0, 0.5);
                  }
                }
              }
            }
          }

          .toMaterial {
              position: absolute;
              top: 14px;
              left: 14px;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              width: 104px;
                height: 30px;
                background: rgba(65, 180, 140, 0.7);
                border-radius: 15px;
                user-select: none;
                cursor: pointer;

              i {
                  display: block;
                  width: 16px;
                  height: 16px;
                  background: url('./assets/send.png') no-repeat;
                  background-position: center center;
                  background-size: 100% 100%;
                  margin-right: 6px;
              }

              span {
                  font-size: 14px;
                  line-height: 20px;
                  color: #FFFFFF;
                  font-weight: 800;
              }
          }
        }

        .info {
            display: flex;
            flex-direction: column;

            .title {
                font-size: 0.16em;
                line-height: 1.375em;
                padding-bottom: 0.875em;   
                font-weight: bold;
                border-bottom: 1px solid #EEEEEE;
                box-sizing: border-box;
                margin-bottom: 0.13em;
            }

            ul {
                display: flex;
                flex-direction: column;
                padding-right: 0.82em;
                box-sizing: border-box;

                li {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    margin-top: 0.13em;

                    .tag {
                        background: url('./assets/tag.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                    }

                    .zan {
                        background: url('./assets/zan.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                    }

                    .upload {
                        background: url('./assets/upload.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                    }

                    .comment {
                        background: url('./assets/comment.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                    }

                    .user {
                        background: url('./assets/user.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                    }

                    .share {
                        background: url('./assets/share.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                    }

                    .time {
                        background: url('./assets/time.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                    }

                    .left {
                        display: flex;
                        flex-direction: row;
                        align-items: center;

                        i {
                            display: block;
                            width: 0.2em;
                            height: 0.2em;
                            margin-right: 10px;
                        }

                        span {
                            font-size: 0.14em;
                            line-height: 1.429em;
                            color: #050F0F;
                        }
                    }

                    .right {
                        display: flex;
                        flex-direction: row;
                        align-items: center;

                        i {
                            display: block;
                            width: 0.2em;
                            height: 0.2em;
                            margin-right: 10px;
                        }

                        span {
                            font-size: 0.14em;
                            line-height: 1.429em;
                            color: #050F0F;
                        }
                    }
                }
            }
        }

        .btns {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            margin-top: 0.3em;

            .btn {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                width: 200px;
                height: 40px;
                border-radius: 20px;
                border: 1px solid #41B48C;
                box-sizing: border-box;
                user-select: none;
                cursor: pointer;

                // &:nth-of-type(1) {
                //     margin-right: 0.1em;
                // }

                .link {
                    display: block;
                    width: 0.2em;
                    height: 0.2em;
                    background: url('./assets/link.png') no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    margin-right: 0.1em;
                }

                .download {
                    display: block;
                    width: 0.2em;
                    height: 0.2em;
                    background: url('./assets/download.png') no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    margin-right: 0.1em;
                }

                span {
                    font-size: 0.14em;
                    color: #41B48C;
                }
            }
        }
    }
</style>